// extracted by mini-css-extract-plugin
export default {"cart":"CartItem_cart__wQsDQ","quantity":"CartItem_quantity__EIJ-S","remove":"CartItem_remove__nGk-h"};